import React from 'react'
import { Link } from "react-router-dom";


const HomeServices = () => {
  return (
    <>
    
   <div className="service-area bg py-100" style={{marginTop:"-80px"}}>
  <div className="container">
    <div className="row">
      <div className="col-lg-6 mx-auto">
        <div className="site-heading text-center wow fadeInDown" data-wow-delay=".25s" style={{visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInDown'}}>
          <span className="site-title-tagline"><i className="far fa-solar-panel" /> Our Services</span>
          <h2 className="site-title">What Services we are <span>provide</span> to you</h2>
          <div className="heading-divider" />
        </div>
      </div>
    </div>
    <div className="row g-4 wow fadeInUp" data-wow-delay=".25s" style={{visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp'}}>
      <div className="col-md-6 col-lg-3">
        <div className="service-item">
          <span className="count">01</span>
          <div className="service-img">
            <img src="assets/yog/Installation.webp" alt />
          </div>
          <div className="service-icon">
            <img src="assets/img/icon/solar.svg" alt />
          </div>
          <div className="service-content">
            <h4 className="service-title">
              <Link to="/solar-electrical-installation">Solar & Electrical Installation</Link>
            </h4>
            <p className="service-text">
              
            </p>
            <Link to="/solar-electrical-installation" className="theme-btn"><b>Learn More</b><i className="fas fa-arrow-right" /></Link>
          </div>
        </div>
      </div>
      <div className="col-md-6 col-lg-3">
        <div className="service-item">
          <span className="count">02</span>
          <div className="service-img">
            <img src="assets/img/service/02.jpg" alt />
          </div>
          <div className="service-icon">
            <img src="assets/img/icon/wind.svg" alt />
          </div>
          <div className="service-content">
            <h4 className="service-title">
              <Link to="/on-grid-off-grid-solar">On-Grid & Off-Grid Solar</Link>
            </h4>
            <p className="service-text">
              
            </p>
            <Link to="/on-grid-off-grid-solar" className="theme-btn"><b>Learn More</b><i className="fas fa-arrow-right" /></Link>
          </div>
        </div>
      </div>
      <div className="col-md-6 col-lg-3">
        <div className="service-item">
          <span className="count">03</span>
          <div className="service-img">
            <img src="assets/yog/Solar Water Heater.webp" alt />
          </div>
          <div className="service-icon">
            <img src="assets/img/icon/install-2.svg" alt />
          </div>
          <div className="service-content">
            <h4 className="service-title">
              <Link to="/solar-water-heater-solution">Solar Water Heater Solution</Link>
            </h4>
            <p className="service-text">
              
            </p>
            <Link to="/solar-water-heater-solution" className="theme-btn"><b>Learn More</b><i className="fas fa-arrow-right" /></Link>
          </div>
        </div>
      </div>
      <div className="col-md-6 col-lg-3">
        <div className="service-item">
          <span className="count">04</span>
          <div className="service-img">
            <img src="assets/img/service/07.jpg" alt />
          </div>
          <div className="service-icon">
            <img src="assets/img/icon/install.svg" alt />
          </div>
          <div className="service-content">
            <h4 className="service-title">
              <Link to="/energy-efficient-building">Energy Efficient Building</Link>
            </h4>
            <p className="service-text">
              
            </p>
            <Link to="/energy-efficient-building" className="theme-btn"><b>Learn More</b><i className="fas fa-arrow-right" /></Link>
          </div>
        </div>
      </div>
      <div className="col-md-6 col-lg-3">
        <div className="service-item">
          <span className="count">05</span>
          <div className="service-img">
            <img src="assets/yog/Hybrid Solar Power Plant.webp" alt />
          </div>
          <div className="service-icon">
            <img src="assets/img/icon/hydraulic.svg" alt />
          </div>
          <div className="service-content">
            <h4 className="service-title">
              <Link to="/hybrid-solar-power-plant" style={{fontSize:"20px"}}>Hybrid Solar Power Plant</Link>
            </h4>
            <p className="service-text">
              
            </p>
            <Link to="/hybrid-solar-power-plant" className="theme-btn"><b>Learn More</b><i className="fas fa-arrow-right" /></Link>
          </div>
        </div>
      </div>
      <div className="col-md-6 col-lg-3">
        <div className="service-item">
          <span className="count">06</span>
          <div className="service-img">
            <img src="assets/yog/EV Charging Solution.webp" alt />
          </div>
          <div className="service-icon">
            <img src="assets/img/icon/fossil.svg" alt />
          </div>
          <div className="service-content">
            <h4 className="service-title">
              <Link to="/EV-charging-solution">EV Charging Solution</Link>
            </h4>
            <p className="service-text">
              
            </p>
            <Link to="/EV-charging-solution" className="theme-btn"><b>Learn More</b><i className="fas fa-arrow-right" /></Link>
          </div>
        </div>
      </div>
      <div className="col-md-6 col-lg-3">
        <div className="service-item">
          <span className="count">07</span>
          <div className="service-img">
            <img src="assets/yog/Solar Water Pump Solution.webp" alt />
          </div>
          <div className="service-icon">
            <img src="assets/img/icon/renewable.svg" alt />
          </div>
          <div className="service-content">
            <h4 className="service-title">
              <Link to="/solar-water-pump-solution" style={{fontSize:"19px"}}>Solar Water Pump Solution</Link>
            </h4>
            <p className="service-text">
              
            </p>
            <Link to="/solar-water-pump-solution" className="theme-btn"><b>Learn More</b><i className="fas fa-arrow-right" /></Link>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

    
    </>
  )
}

export default HomeServices